import {
  BooleanSelect,
  BooleanSelectProps,
} from "./dynamic-attribute-field-simple-boolean-select";

export function DynamicAttributeFieldSimpleBoolean(props: BooleanSelectProps) {
  return <BooleanSelect {...props} />;
}
